import { Box, Text, Tooltip, Button } from '@chakra-ui/react';
import React from 'react';

import { finleyBuffer } from '@finley-technologies/common';
import { TapeBuilderUI } from '@finley-technologies/tape-builder';
import { extractVirtualSheetConfiguration } from '@finley-technologies/tape-sanitizer';

import { FileUploadButton } from '../calcAgentQA/FileUploadButton';
import { ConfigureParams } from './types';
import { convertErrorToStringMessages } from 'packages/tapeBuilder/ui/calcAgentQA/convertErrorToStringMessages';

type Props = {
  onAutoConfigure: (configuration: ConfigureParams) => void;
  tapeBuilderNode: TapeBuilderUI.TapeBuilderNodeAbstract;
};
export const AutoConfigurePyCsvVirtualSheetPanel = ({
  tapeBuilderNode,
  onAutoConfigure,
}: Props) => {
  const { configuration } = tapeBuilderNode;

  if (
    !TapeBuilderUI.operationNodes.operation_pyCsvVirtualSheet.isConfig(
      configuration,
    )
  ) {
    return (
      <Tooltip label="Invalid configuration schema">
        <Button type="button" isDisabled w="full">
          Configure
        </Button>
      </Tooltip>
    );
  }

  const { fields } = configuration;
  return (
    <Box mb="2">
      <Text mb="2">
        Generate config from XLSX tab &quot;finleyVirtualSheet&quot;
      </Text>
      <Text mb="2">
        Reference input csvs using their artifactSlug as xlsx sheetNames.
      </Text>
      <FileUploadButton
        allowedExtensions={['xlsx']}
        buttonText="Upload Config"
        handleFile={async (arrayBuffer: ArrayBuffer) => {
          try {
            const virtualSheet = await extractVirtualSheetConfiguration({
              buffer: finleyBuffer.fromArrayBuffer(arrayBuffer),
            });
            onAutoConfigure({
              isValid: true,
              operation: 'pyCsvVirtualSheet',
              configuration: {
                fields,
                operation: 'pyCsvVirtualSheet',
                virtualSheet,
              },
            });
          } catch (e) {
            const errors = convertErrorToStringMessages(e);
            onAutoConfigure({
              isValid: false,
              operation: 'pyCsvVirtualSheet',
              errors,
            });
          }
        }}
      />
    </Box>
  );
};
